import { message } from 'antd';
import axios from '../../utils/axiosInstance';

export const bookCar = (reqObj) => async (dispatch) => {
    dispatch({ type: 'LOADING', payload: true });
    try {
        // Updated request body includes distance, totalAmount, and new fields
        await axios.post('https://luxurylifelimo.onrender.com/api/bookings/bookcar', reqObj);

        dispatch({ type: 'LOADING', payload: false });
        message.success("Your car has been booked successfully");
        setTimeout(() => {
            window.location.href = '/userbookings'; // Redirect to user bookings
        }, 500);
    } catch (error) {
        console.log(error);
        dispatch({ type: 'LOADING', payload: false });
        message.error("Something went wrong");
    }
};

export const getAllBookings = () => async (dispatch) => {
    dispatch({ type: 'LOADING', payload: true });
    try {
        const response = await axios.get('/api/bookings/getallbookings');

        console.log("RESPONSE DATA", response.data);
        dispatch({ type: 'GET_ALL_BOOKINGS', payload: response.data });

        dispatch({ type: 'LOADING', payload: false });
    } catch (error) {
        console.log(error);
        dispatch({ type: 'LOADING', payload: false });
    }
};

export const getUserBookings = (userId) => async (dispatch) => {
    dispatch({ type: 'LOADING', payload: true });
    try {
        const response = await axios.post('/api/bookings/getuserbookings', { userId });
        console.log("📤 Dispatching userId:", userId);

        dispatch({ type: 'GET_ALL_BOOKINGS', payload: response.data });
        dispatch({ type: 'LOADING', payload: false });
    } catch (error) {
        console.log(error);
        dispatch({ type: 'LOADING', payload: false });
    }
};
